import React from 'react'
import Category from '../../Components/client/Category'
function Categories() {
  return (
    <div>
      <Category/>
    </div>
  )
}

export default Categories
